import webuiState from "../app/InternalStateService";
import webuiTranslations from "../app/TranslationService";
import { extractStorePath } from "../utils/storeUtils";

const SET_LANGUAGE = "SET_LANGUAGE";

//sets new locale, specified in an action
export function changeLanguageFromSirenAction(action, widgetId, path) {
    return async (dispatch, getState) => {
        let newLocale;
        let properties = action.properties || {};

        if (properties.hasOwnProperty("value")) {
            // new action format { actionType: "changeLanguage", properties: { value: "fr-FR"}}
            newLocale = properties.value;
        } else if (action.locale) {
            // old action format { actionType: "changeLanguage", locale: "fr-FR"}
            newLocale = action.locale;
        } else {
            //getInput location in store
            let inputLocation = extractStorePath(path, getState());
            newLocale = getState()
                .get("data")
                .getIn(inputLocation)
                .getIn(["properties", "value"]);
        }
        let currentLocale = getState().getIn(["global", "locale"]);

        if (currentLocale === newLocale) {
            return;
        } else {
            dispatch(changeLocale(newLocale));
            await loadTranslations(dispatch);
            return dispatch(webuiState.getActionByName("dashboard.reloadDashboardAndWidgets")());
        }
    };
}
export function changeLocaleFromSirenAction(action) {
    return (dispatch, getState) => {
        let newLocale;
        let properties = action.properties || {};
        // support only new action format { actionType: "changeLanguage", properties: { value: "fr-FR"}}
        if (properties.hasOwnProperty("value")) {
            newLocale = properties.value;
        }
        let currentLocale = getState().getIn(["global", "locale"]);

        if (currentLocale === newLocale) {
            return;
        }

        return dispatch(changeLocale(newLocale));
    };
}

function changeLocale(locale) {
    return dispatch => {
        //setting webui state locale, dateLocale
        //used for translations
        webuiState.changeLocale(locale);
        return dispatch(setLocale(locale));
    };
}

export function changeStaticTranslationLanguageSiren(action) {
    return async dispatch => {
        webuiState.changeLocale(action.language);
        await loadStaticTranslation(dispatch);
        dispatch(setLocale(action.language));
        return dispatch(webuiState.getActionByName("dashboard.reloadDashboardAndWidgets")());
    };
}

export async function loadStaticTranslation(dispatch) {
    let language = webuiState.getGlobalProperties("locale");
    if (
        webuiState.getGlobalProperties("staticTranslations") &&
        !webuiState.getStaticTranslation(language)
    ) {
        let translations = await dispatch(
            webuiState.getActionByName("request.request")({
                method: "GET",
                endpoint: `${webuiState.getGlobalProperties(
                    "staticApiPublicPath"
                )}/translations/${language}.json`
            })
        );
        webuiState.setStaticTranslation({ [language]: translations });
    }
}

export function loadTranslationsSiren() {
    return async dispatch => {
        await loadTranslations(dispatch);
    };
}

// dynamically loadTranslations from backend for currently set webui locale
export async function loadTranslations(dispatch) {
    let { API_ROOT } = webuiState.getWebConfig();
    let language = webuiState.getGlobalProperties("locale");
    let url = `${API_ROOT}/common/translations/${language}`;

    let translations = await dispatch(
        webuiState.getActionByName("request.request")({
            endpoint: url,
            method: "GET"
        })
    );

    webuiTranslations.addTranslations(language, translations);
}

function setLocale(locale) {
    return {
        type: SET_LANGUAGE,
        payload: {
            locale
        }
    };
}
